export default __webpack_public_path__ + "static/media/scene-06-proof-in-the-field.04d79ce8.png";